import { Button as AntButton } from 'antd';
import { FilterOutlined } from '@ant-design/icons';
import React from 'react';
import './assets/ButtonStyle.css';

export const FilterButton = ({ ...props }) => {
  return (
    <AntButton className={'filter_button'} {...props}>
      {<FilterOutlined style={{ fontSize: '16px', marginTop: '-2px' }} />}
      {props.children}
    </AntButton>
  );
};

FilterButton.displayName = 'Filter';
